import {qs, createEl} from "../utils/dom.js";
import {appState} from "../state/app-state.js";
import {navigateToOffer} from "../utils/navigation.js";
import {siteName} from "../utils/url.js";

export function renderTopGames() {
  const mount = qs("#top-games");
  if (!mount) {
    return;
  }

  if (!Array.isArray(appState.games) || appState.games.length === 0) {
    console.warn("No games data available");
    return;
  }

  mount.classList.add("topGamesSection");

  const container = qs('.topGamesWrapper');
  const grid = createEl("div", {className: "games"});
  const visibleCount = 12;

  appState.games.slice(0, visibleCount).forEach((game) => {
    const card = createEl("div", {className: "gameCard"});

    if (appState.offer) {
      card.addEventListener("click", () => {
        navigateToOffer(appState.offer.id, appState.offer.link);
      });
    }
    const img = createEl("img");

    img.src = game.image
      ? `https://panvfg.com/images/games/${game.image}`
      : "./public/images/game-placeholder.webp";
    img.alt = `${game.name} in ${siteName}`;
    img.title = `${game.name} in ${siteName}`;
    img.loading = 'lazy';
    img.onerror = function () {
      this.src = "./public/images/game-placeholder.webp";
    };

    const info = createEl("div", {className: "gameInfo"});
    const name = createEl("h3", {text: game.name || "Game"});
    const playBtn = createEl("a", {
      className: "button-secondary",
      attrs: {href: appState.offer ? `casino/${appState.offer.id}` : "#"},
    });
    playBtn.textContent = "Play now";
    if (appState.offer) {
      playBtn.addEventListener("click", (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        navigateToOffer(appState.offer.id, appState.offer.link);
      });
    }

    info.appendChild(name);
    info.appendChild(playBtn);
    card.appendChild(img);
    card.appendChild(info);
    grid.appendChild(card);
  });

  container.appendChild(grid);

  const allBtn = createEl("a", {
    className: "button-primary topGames_button",
    attrs: { href: `casino/${appState.offer.id}` },
  });

  allBtn.textContent = "All games";
  if (appState.offer) {
    allBtn.addEventListener("click", (ev) => {
      ev.preventDefault();
      navigateToOffer(appState.offer.id, appState.offer.link);
    });
  }

  container.appendChild(allBtn);
  mount.appendChild(container);
}
